<template>
  <div v-loading="loading">
    <div class="edit">
      <el-row>
        <el-col style="width: 85px; line-height: 38px; ">星级规则：</el-col>
        <el-col :span="20">
          <el-form
            ref="editList"
            :model="formData"
            label-width="50px"
            class="demo-dynamic">
            <el-form-item
              v-for="(item, index) in formData.editList"
              :label="`${index + 1}星`"
              :key="index"
              :error="listErrors[index]"
            >
              <el-input
                v-model="item.level_alias"
                placeholder="输入评级"/>
              获得<el-input
                v-model="item.star_num"
                oninput="value = value.replace(/[^\d]/g,'')"
                type="text"/>小苹果， <span class="red_name">课中：</span>
              <el-input
                v-model="item.min_percent"
                oninput="value = value.replace(/[^\d]/g,'')"
                type="text"/>% &lt; 百分比 ≤
              <el-input
                v-model="item.max_percent"
                oninput="value = value.replace(/[^\d]/g,'')"
                type="text"/> %  <span class="red_name">课后：</span>
              <el-input
                v-model="item.min_other_percent"
                oninput="value = value.replace(/[^\d]/g,'')"
                type="text"/>% &lt; 百分比 ≤
              <el-input
                v-model="item.max_other_percent"
                oninput="value = value.replace(/[^\d]/g,'')"
                type="text"/> %
              <el-button
                v-if="(index+1) === formData.editList.length"
                class="del"
                @click.prevent="removeDomain(item)">删除</el-button>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click="addDomain">新增星级</el-button>
              <el-button
                type="primary"
                @click="submitForm()">提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="admin.realname"
        label="操作人"
        width="180"/>
      <el-table-column
        prop="created_at"
        label="操作时间"
        width="180"/>
      <el-table-column
        label="操作内容">
        <template slot-scope="scope">
          <div
            class="content"
            v-html="scope.row.content" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="10"
      :total="pageTotal"
      class="page"
      background
      layout="total, prev, pager, next"
      @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
import { $http } from "@/utils";

export default {
  name: "CourseConfig",
  data() {
    return {
      loading: true,
      tableData: [],
      formData: {
        editList: [],
      },
      listErrors: [],
      page: 1,
      pageTotal: 0,
    };
  },
  created() {
    this.load();
    this.loadLog(this.page);
  },
  methods: {
    BlurText(e) {
      const boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
      if (!boolean) {
        this.$alert("请输入正整数！");
      }
    },
    load() {
      this.loading = true;
      $http.get("/config/study_report_gradient", {})
        .then((res) => {
          this.formData.editList = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
    loadLog(page) {
      this.loading = true;
      $http.get(`/config/logs/student.study_report.in_class.gradient?page=${page}&per_page=10`, {})
        .then((res) => {
          this.loading = false;
          this.pageTotal = res.total;
          this.tableData = res.data.map((item) => {
            let html = "";
            item.value.forEach((list, index) => {
              html += '<span style="margin-right: 20px;">' +
                      `${index + 1}星 ${list.level_alias} 获得${list.star_num}个小苹果 ` +
                      `<span style="color: red;">课中：</span>${list.min_percent}% < 百分比 ≤ ${list.max_percent}% ` +
                      `<span style="color: red;">课后：</span>${list.min_other_percent}% < 百分比 ≤ ${list.max_other_percent}%` +
                      '</span>';
            });
            return { ...item, content: html };
          });
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.loadLog(val);
    },
    listValidate() {
      const errorMessage = "星级规则必须补充完整";
      const list = this.formData.editList;
      let result = true;
      this.listErrors = list.map(({
        star_num,
        min_percent,
        min_other_percent,
        max_percent,
        max_other_percent,
      }) => {
        const max = Number(max_percent);
        const min = Number(min_percent);
        const max_o = Number(max_other_percent);
        const min_o = Number(min_other_percent);
        const valid = !!(star_num && min_percent && max_percent && min_other_percent && max_other_percent);
        const num = (min >= 0 && max <= 100) && (min_o >= 0 && max_o <= 100);
        result = result && valid && num;
        return valid && num ? "" : !num ? "百分比必须在0-100之间！" : errorMessage;
      });
      return result;
    },
    submitForm() {
      const valid = this.listValidate();
      if (valid) {
        this.loading = true;
        const data = {
          value: this.formData.editList,
        };
        $http.put("/config/study_report_gradient", data)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
            });
            this.load();
            this.loadLog(this.page);
          })
          .catch((err) => {
            this.$notify.error({
              title: "错误",
              message: err.message,
            });
            this.loading = false;
          });
      }
    },
    removeDomain(item) {
      const index = this.formData.editList.indexOf(item);
      this.$confirm("是否删除规则？").then(() => {
        if (index !== -1) {
          this.formData.editList.splice(index, 1);
        }
      });
    },
    addDomain() {
      this.formData.editList.push({
        star_num: "", min_percent: "", max_percent: "", level_alias: "",
      });
    },
  },
};
</script>

<style scoped>
  .page{
    margin-top: 30px;
    text-align: center;
  }
  .edit .el-input{
    width: 90px;
    margin: 0 10px;
  }
  .edit .del{
    margin: 0 10px;
  }
  .red_name {
    color: red;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }
</style>
<style>
  .edit .el-form-item .el-form-item__label{
    font-size: 16px;
    font-weight: bold;
  }
  .edit .btn .el-form-item__content{
    margin-left: 0 !important;
  }
</style>
